module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "uk-modal"
  }, [_c('div', {
    class: {
      'uk-modal-dialog': true,
      'uk-modal-dialog-lightbox': _vm.lightbox,
      'uk-modal-dialog-blank': _vm.blank,
      'uk-modal-dialog-large': _vm.large
    }
  }, [(!_vm.lightbox) ? _vm._t("header", [_c('div', {
    staticClass: "uk-modal-header",
    slot: "header"
  }, [_c('button', {
    staticClass: "uk-modal-close uk-close uk-float-right"
  }), _vm._v(" "), (_vm.title) ? _c('h3', {
    staticClass: "uk-display-inline"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lightbox) ? _c('a', {
    staticClass: "uk-modal-close uk-close uk-close-alt",
    attrs: {
      "href": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (!_vm.lightbox) ? _vm._t("footer") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58e24845!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkModal.vue
// module id = 294
// module chunks = 2